import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { GeographyModel } from "../../models/GeographyModel";
import GeographyService from "../../services/GeographyService";
import GeographySlice from "../slices/GeographySlice";
import { RootState } from "../store";

export const GeographyActions = GeographySlice.actions;
export const fetchGeographies = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(GeographyActions.setIsGeographiesFetching(true));
    const response: GeographyModel[] =
      await GeographyService.getAllGeographies();
    dispatch(GeographyActions.setGeographies(response));
    dispatch(GeographyActions.setIsGeographiesFetching(false));
  };
};
export const fetchParticularGeography = (
  Geography_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: GeographyModel =
      await GeographyService.getParticularGeography(Geography_id);
    dispatch(GeographyActions.setParticularGeography(response));
  };
};
